import { monthCloseOutAlertConstants } from '../../actions/constant';

/**
 * BOPS-115 — create / edit / cancel state for custom closeout periods. Same
 * `{ response, getStatus, loading }` shape as reopenCloseoutReducer so the page can read all four
 * mutations the same way.
 */

const {
  CREATE_CUSTOM_CLOSEOUT_SUCCESS,
  CREATE_CUSTOM_CLOSEOUT_FAILURE,
  CREATE_CUSTOM_CLOSEOUT_LOADING,
  CREATE_CUSTOM_CLOSEOUT_RESET,
  UPDATE_CUSTOM_CLOSEOUT_SUCCESS,
  UPDATE_CUSTOM_CLOSEOUT_FAILURE,
  UPDATE_CUSTOM_CLOSEOUT_LOADING,
  UPDATE_CUSTOM_CLOSEOUT_RESET,
  CANCEL_CUSTOM_CLOSEOUT_SUCCESS,
  CANCEL_CUSTOM_CLOSEOUT_FAILURE,
  CANCEL_CUSTOM_CLOSEOUT_LOADING,
  CANCEL_CUSTOM_CLOSEOUT_RESET,
} = monthCloseOutAlertConstants;

const intitialstate: object = {
  response: null,
  getStatus: false,
  loading: false,
};

const buildReducer =
  (SUCCESS: string, FAILURE: string, LOADING: string, RESET: string) =>
  (state = intitialstate, action: any) => {
    switch (action.type) {
      case SUCCESS:
        return { ...state, getStatus: true, response: action.payload, loading: false };

      case FAILURE:
        return { ...state, getStatus: false, response: action.payload, loading: false };

      case LOADING:
        return { ...state, loading: true };

      case RESET:
        return intitialstate;

      default:
        return state;
    }
  };

export const createCustomCloseoutReducer = buildReducer(
  CREATE_CUSTOM_CLOSEOUT_SUCCESS,
  CREATE_CUSTOM_CLOSEOUT_FAILURE,
  CREATE_CUSTOM_CLOSEOUT_LOADING,
  CREATE_CUSTOM_CLOSEOUT_RESET
);

export const updateCustomCloseoutReducer = buildReducer(
  UPDATE_CUSTOM_CLOSEOUT_SUCCESS,
  UPDATE_CUSTOM_CLOSEOUT_FAILURE,
  UPDATE_CUSTOM_CLOSEOUT_LOADING,
  UPDATE_CUSTOM_CLOSEOUT_RESET
);

export const cancelCustomCloseoutReducer = buildReducer(
  CANCEL_CUSTOM_CLOSEOUT_SUCCESS,
  CANCEL_CUSTOM_CLOSEOUT_FAILURE,
  CANCEL_CUSTOM_CLOSEOUT_LOADING,
  CANCEL_CUSTOM_CLOSEOUT_RESET
);
